module.exports = {"title":"How to Run","body":"<p>Mostly you need to move your legs and arms together in coordinated\nfashion faster than you normally would when you’re moving your body\naround. If you do this and don’t look too weird, people will believe\nyou’re running.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./docs/how-to-run/index.md
// module id = 469
// module chunks = 0